import { Modal } from "App/Component/ui";
import { STYLE_DEFAULT_MASTER } from "App/constants";
import React, { useState, useContext } from "react";
import { RenderContentDaftarPenjualan } from "App/Component/layout/Penjualan/DaftarPenjualan/DaftarPenjualan";
import { FormContext } from "../../../../context/FormContext";
import {
  getByID,
  addInsuranceAndKelasToListBarang,
  addTotalToItemArray,
} from "App/Component/layout/Penjualan/DaftarPenjualan/helpers";
import { defaultDateInputDisplay, isNull } from "App/utils/helpers";

const useStyles = STYLE_DEFAULT_MASTER;

export default function ModalListPenjualan({ setShowModal, setModalParent }) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const { setFormData } = useContext(FormContext);

  const handleClickUpdate = async (row) => {
    setLoading(true);
    const res = await getByID(row.id);
    const propsPageInputPenjualan = {
      penjualan_id: res.data.id,
      idExt: res.data.id,
      date: defaultDateInputDisplay(res.data.date, true),

      status_transaksi: row.status_transaksi,
      id_type_of_care: res.data.id_type_of_care,
      asuransi_id: res.data.insurance_id,
      asuransi: res.data.namaAsuransi,
      noasuransi: res.data.insurance_no,

      kelas_id: res.data.id_kelas,
      kelas_name: res.data.namaKelas,

      kunjungan_id: res.data.id_kunjungan,

      tipe_pembayaran_id: res.data.msTipePembayaranId,
      // tipe_pembayaran_name: res.data.namaTipePembayaran,

      jenis_layanan_id: res.data.id_jenis_layanan,
      jenis_layanan_name: res.data.jenis_layanan_name,

      kas_bank_id: res.data.kas_id,
      kas_bank_name: res.data.namaKas,

      gudang_id: row.gudang_id,
      gudang_name: row.namaGudang,

      is_lock: res.data.is_lock,
      tgl_lock: res.data.tgl_lock,

      is_close: res.data.is_close,
      tgl_close: res.data.tgl_close,

      isUpdate: true,

      rm_id: res.data.id_rm,
      jenisrm: 2,
      type: "update",
      petugas: res.data.petugas,
      dokter_id: res.data.id_dokter,
      dokter_name: res.data.namaDokter,
      is_external: res.data.isExternal,

      // RM External
      nama: res.data.isExternal ? res.data.namaRMExt : res.data.nama_rm,
      tagihan_id: res.data.isExternal ? row.tagihanIdExt : row.tagihanIdKunj,
      keterangan: res.data.keterangan,
      intext: isNull(res.data.intext) ? 1 : res.data.intext,

      fasilitas: addTotalToItemArray(res.data.fasilitas),
      jasa: addTotalToItemArray(res.data.jasa),
      rikjang: addTotalToItemArray(res.data.rikjang),
      barang: addInsuranceAndKelasToListBarang(
        res.data.barang,
        res.data.id_kelas,
        res.data.insurance_id
      ),
      paket: addTotalToItemArray(res.data.paket),

      potongan: res.data.jumlah_set_discount,

      potongan2: res.data.jumlah_set_discount,
      pembayaran: res.data.bayar_jual,

      tax_percent: res.data.tax,
      tax: res.data.tax,
    };

    setFormData(propsPageInputPenjualan);
    // setFormData({
    //   penjualan_id: res.data.id,
    //   idExt: res.data.id,
    //   date: defaultDateInputDisplay(res.data.date, true),

    //   asuransi_id: res.data.insurance_id,
    //   asuransi: res.data.namaAsuransi,
    //   noasuransi: res.data.insurance_no,

    //   kelas_id: res.data.id_kelas,
    //   kelas_name: res.data.namaKelas,

    //   kunjungan_id: res.data.id_kunjungan,

    //   tipe_pembayaran_id: res.data.msTipePembayaranId,
    //   // tipe_pembayaran_name: res.data.namaTipePembayaran,

    //   jenis_layanan_id: res.data.id_jenis_layanan,
    //   jenis_layanan_name: res.data.jenis_layanan_name,

    //   kas_bank_id: res.data.kas_id,
    //   kas_bank_name: res.data.namaKas,

    //   gudang_id: row.gudang_id,
    //   gudang_name: row.namaGudang,

    //   is_lock: res.data.is_lock,
    //   tgl_lock: res.data.tgl_lock,

    //   is_close: res.data.is_close,
    //   tgl_close: res.data.tgl_close,

    //   isUpdate: true,

    //   rm_id: res.data.id_rm,
    //   jenisrm: 2,
    //   type: "update",
    //   petugas: res.data.petugas,
    //   dokter_id: res.data.id_dokter,
    //   dokter_name: res.data.namaDokter,
    //   is_external: res.data.isExternal,

    //   // RM External
    //   nama: res.data.isExternal ? res.data.namaRMExt : res.data.nama_rm,
    //   tagihan_id: res.data.isExternal ? row.tagihanIdExt : row.tagihanIdKunj,
    //   keterangan: res.data.keterangan,
    //   intext: isNull(res.data.intext) ? 1 : res.data.intext,

    //   fasilitas: addTotalToItemArray(res.data.fasilitas),
    //   jasa: addTotalToItemArray(res.data.jasa),
    //   rikjang: addTotalToItemArray(res.data.rikjang),
    //   barang: addInsuranceAndKelasToListBarang(
    //     res.data.barang,
    //     res.data.id_kelas,
    //     res.data.insurance_id
    //   ),
    //   paket: addTotalToItemArray(res.data.paket),

    //   potongan: res.data.jumlah_set_discount,

    //   potongan2: res.data.jumlah_set_discount,
    //   pembayaran: res.data.bayar_jual,

    //   tax_percent: res.data.tax,
    //   tax: res.data.tax,
    // });
    // await setNewBarangDijual();
    setLoading(false);
    setShowModal(false);
    setModalParent(false);
  };
  return (
    <Modal
      title={"Pencarian Penjualan"}
      width={"70%"}
      show={() => {
        setShowModal(false);
        setModalParent(false);
      }}>
      <RenderContentDaftarPenjualan
        handleClickUpdate={handleClickUpdate}
        classes={classes}
        loading={loading}
        setLoading={setLoading}
      />
    </Modal>
  );
}
